import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  brokers: [],
  loading: false,
  error: null,
};

const brokerSlice = createSlice({
  name: "brokers",
  initialState,
  reducers: {
    setBrokers: (state, action) => {
      const sortData = action.payload;
      const sort = sortData?.sort((a, b) => (a.name > b.name ? 1 : -1));
      state.brokers = sort;
      state.loading = false;
      state.error = null;
    },
    addBroker: (state, action) => {
      const newBroker = action.payload;
      if (state?.brokers?.find((a) => a?.brokerId !== newBroker?.brokerId)) {
        state.brokers = [...state.brokers, newBroker];
        toast.success(`${newBroker.name} added successfully`);
      }
      state.loading = false;
      state.error = null;
    },
    updateBroker: (state, action) => {
      const updatedBroker = action.payload;
      const existingBrokerIndex = state.brokers.findIndex(
        (a) => a?.brokerId === updatedBroker?.brokerId
      );

      if (existingBrokerIndex !== -1) {
        state.brokers[existingBrokerIndex] = updatedBroker;
        toast.success(`${updatedBroker.name} updated successfully`);
      } else {
        state.brokers.push(updatedBroker);
        toast.success(`${updatedBroker.name} added successfully`);
      }
      state.loading = false;
      state.error = null;
    },
    deleteBroker: (state, action) => {
      const brokerIdToDelete = action.payload?.brokerId;
      const brokerToDelete = state.brokers.find(
        (a) => a?.brokerId === brokerIdToDelete
      );
      
      state.brokers = state.brokers.filter((a) => a?.brokerId !== brokerIdToDelete);
      
      if (brokerToDelete) {
        toast.success(`${brokerToDelete.name} deleted successfully`);
      }
      state.loading = false;
      state.error = null;
    },
    setBrokerLoading: (state, action) => {
      state.loading = action.payload;
    },
    setBrokerError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setBrokers,
  addBroker,
  updateBroker,
  deleteBroker,
  setBrokerLoading,
  setBrokerError,
} = brokerSlice.actions;

// Selectors
export const selectBrokers = (state) => state.brokers.brokers;
export const selectBrokersLoading = (state) => state.brokers.loading;
export const selectBrokersError = (state) => state.brokers.error;

export default brokerSlice.reducer;
